import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import BooleanIcon from 'UI/BooleanIcon'
import { includes, map, compact, uniqBy, sortBy } from 'lodash'

import { VMReportFilters as Filters, filteredData } from './Filters';

const VcenterAssetReportVMs = ({ vms, sites }) => {
  const [filters, changeFilters] = useState({ sites: 'all', customers: 'all', inSite: 'all', showPresentCustomers: 'all' })
  const filterOptions = {
    sites: map(compact(sites), ({ code, name }) => ({ label: name, value: code })),
    customers: sortBy(map(uniqBy(compact(map(vms, 'customer')), 'short_name'), ({ id, short_name }) => ({ label: short_name, value: id })), 'label')
  }
  const columns = [
    { Header: 'Site', accessor: 'site.name' },
    { Header: 'Customer', accessor: 'customer.short_name' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'IP', accessor: 'ip_address' },
    {
      Header: 'Power State',
      accessor: 'power_state',
      width: 100,
      Cell: ({ value: powerState }) => (
        <BooleanIcon {...{
          booleanValue: powerState === 'PoweredOn',
          trueIcon: { text: powerState.replace('Powered', ''), icon: 'power-off' },
          falseIcon: { text: powerState.replace('Powered', ''), icon: 'power-off' }
        }} />
      )
    },
  ]

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, filterOptions }} />

      <ReactTable
        data={filteredData({ vms, filters })}
        columns={columns}
        filterable
        defaultFilterMethod={(filter, row) => includes(row[filter.id], filter.value)}
        minRows={0}
      />
    </Fragment>
  )
}

export default VcenterAssetReportVMs
